import { Platform } from 'react-native';
import * as Crypto from 'expo-crypto';
import * as Device from 'expo-device';
import Constants from 'src/core/utils/Constants';
import { MmkvStore } from 'src/data/services/MmkvStorage';

/**
 * Device metadata sent to the backend on push registration.
 */
export interface DeviceMetadata {
	installationId: string;
	deviceName: string;
	deviceModel: string;
	platformName: string;
	platformVersion: string;
}

class DeviceService {
	/**
	 * Stable per-install identifier, persisted in MMKV.
	 */
	getInstallationId(): string {
		const existing = MmkvStore.get(Constants.storageInstallationId);
		if (existing) {
			return existing;
		}

		const installationId = Crypto.randomUUID();
		MmkvStore.set(Constants.storageInstallationId, installationId);
		return installationId;
	}

	getMetadata(): DeviceMetadata {
		return {
			installationId: this.getInstallationId(),
			deviceName: Device.deviceName ?? 'unknown',
			deviceModel: Device.modelName ?? 'unknown',
			platformName: Platform.OS,
			platformVersion: String(Platform.Version),
		};
	}
}

export default new DeviceService();
